import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const updateExceptions = async ({ data }) => {
    const payload = {
        slots: Object.entries(data.exceptions ?? {}).flatMap(
            ([, exception]) => {
                const dates = exception.Dates?.[0];
                const times = exception.Times ?? [];

                return times.map((time) => ({
                    availabilityGuid: time.availabilityGuid || null,
                    startDate: dates?.startDate || null,
                    endDate: dates?.endDate || null,
                    startTime: dates?.allDay ? "00:00" : time.startTime || null,
                    endTime: dates?.allDay ? "00:00" : time.endTime || null,
                    isDisabled: !exception.enabled ? 1 : 0,
                }));
            },
        ),
    };

    const res = await api.post(`/Clinician/Availability`, payload);

    return res.data;
};

export const useUpdateExceptions = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateExceptions,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["availability"],
            });
            toast.success("Time off updated");
        },
        onError: () => {
            toast.error("Error updating time off");
        },
    });
};
